



































































import mixins from 'vue-typed-mixins'
import Navigation from '@/calendesk/mixins/Navigation'
import AdditionalPagesMenu from '@/calendesk/sections/navbar/components/AdditionalPagesMenu.vue'
import Page from '@/calendesk/models/DTO/Response/Page'
import DefaultButton from '@/calendesk/sections/section/components/DefaultButton.vue'
export default mixins(Navigation).extend({
  name: 'Navbar7',
  methods: {
    buttonBackground (page: Page) {
      return {
        background:
          (this.currentPage && this.currentPage.uuid === page.uuid)
            ? this.draftConfiguration.wb_color_primary__color__
            : 'transparent'
      }
    }
  },
  components: { DefaultButton, AdditionalPagesMenu }
})
